import { z } from "zod";

export const workOrderSchema = z.object({
  name: z.string().min(1, { message: "El nombre debe ser valido" }),
  code: z.string().min(1, { message: "El código debe ser valido" }),
  clientEntityId: z
    .string()
    .min(1, { message: "Debe seleccionar una compañía" }),
  zoneId: z.string().min(1, { message: "Debe seleccionar una zona" }),
  enabled: z.boolean().default(true),
});
